<template>
<div class="chapter">
<div class="inner_page">
<p class="fm1">And for Alpheus Thomas Mason and Jerome Blum, who many years ago tried to teach me something about biography and history.</p>
<p class="fm2"><span>—H.M.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?3e887751